import { PageActionsStyles } from '@/components'
import { toThemePixels } from '@/utils'
import styled from 'styled-components'

export const PageActions = styled(PageActionsStyles)``

export const PageTitle = styled.div`
  margin-bottom: ${toThemePixels(8)};
`
